import { createSignal } from 'solid-js'

const [translationsList, setTranslationsList] = createSignal<HTMLDivElement>()

const registerTranslationListRef = (element: HTMLDivElement) => {
  setTranslationsList(element)
}

export {
  translationsList,
  setTranslationsList,
  registerTranslationListRef
}